import { useState, useEffect } from "react";
import QrImg from "./QrImg";
import arr from "../assets/arrow.svg";
import Calendar from "react-calendar";
import moment from "moment";
import "react-calendar/dist/Calendar.css";

function Future({ setType, type, passId }) {
  const [initial, setInitial] = useState(new Date());
  const [final, setFinal] = useState(() => {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 3);
    return currentDate;
  });
  const [start, setStart] = useState(false);
  const [end, setEnd] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setData(null);
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_BASE_URL}/items/getMyPasses`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        param: passId,
        startDate: moment(initial).format("YYYY-MM-DD"),
        endDate: moment(final).format("YYYY-MM-DD"),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
      })
      .catch((error) => console.error("Error fetching passes:", error))
      .finally(() => setLoading(false));
  }, [initial, final, passId, setType]);

  useEffect(() => {
    if (initial > final) {
      setFinal(initial);
    }
  }, [initial, final]);

  useEffect(()=>{
    if(data && Object.keys(data).length && data?.groups?.length > 1){
      setType(data?.groups[0])
    }
  },[data,setType])

  const handleFinalChange = (date) => {
    setFinal(date);
    setEnd(false);
  };

  const handleInitialChange = (date) => {
    setInitial(date);
    setStart(false);
  };

  const closeHandler = (event) => {
    event.stopPropagation();
    if (start) {
      handleInitialChange(initial);
    }
    if (end) {
      handleFinalChange(final);
    }
  };

  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center py-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="5em"
            height="5em"
            viewBox="0 0 24 24"
          >
            <path
              fill="#c66a10"
              d="M20.27,4.74a4.93,4.93,0,0,1,1.52,4.61,5.32,5.32,0,0,1-4.1,4.51,5.12,5.12,0,0,1-5.2-1.5,5.53,5.53,0,0,0,6.13-1.48A5.66,5.66,0,0,0,20.27,4.74ZM12.32,11.53a5.49,5.49,0,0,0-1.47-6.2A5.57,5.57,0,0,0,4.71,3.72,5.17,5.17,0,0,1,9.53,2.2,5.52,5.52,0,0,1,13.9,6.45,5.28,5.28,0,0,1,12.32,11.53ZM19.2,20.29a4.92,4.92,0,0,1-4.72,1.49,5.32,5.32,0,0,1-4.34-4.05A5.2,5.2,0,0,1,11.6,12.5a5.6,5.6,0,0,0,1.51,6.13A5.63,5.63,0,0,0,19.2,20.29ZM3.79,19.38A5.18,5.18,0,0,1,2.32,14a5.3,5.3,0,0,1,4.59-4,5,5,0,0,1,4.58,1.61,5.55,5.55,0,0,0-6.32,1.69A5.46,5.46,0,0,0,3.79,19.38ZM12.23,12a5.11,5.11,0,0,0,3.66-5,5.75,5.75,0,0,0-3.18-6,5,5,0,0,1,4.42,2.3,5.21,5.21,0,0,1,.24,5.92A5.4,5.4,0,0,1,12.23,12ZM11.76,12a5.18,5.18,0,0,0-3.68,5.09,5.58,5.58,0,0,0,3.19,5.79c-1,.35-2.9-.46-4-1.68A5.51,5.51,0,0,1,11.76,12ZM23,12.63a5.07,5.07,0,0,1-2.35,4.52,5.23,5.23,0,0,1-5.91.2,5.24,5.24,0,0,1-2.67-4.77,5.51,5.51,0,0,0,5.45,3.33A5.52,5.52,0,0,0,23,12.63ZM1,11.23a5,5,0,0,1,2.49-4.5,5.23,5.23,0,0,1,5.81-.06,5.3,5.3,0,0,1,2.61,4.74A5.56,5.56,0,0,0,6.56,8.06,5.71,5.71,0,0,0,1,11.23Z"
            >
              <animateTransform
                attributeName="transform"
                dur="1.5s"
                repeatCount="indefinite"
                type="rotate"
                values="0 12 12;360 12 12"
              />
            </path>
          </svg>
        </div>
      ) : (
        <div>
          <div onClick={closeHandler}>
            {data && Object.keys(data).length>0 && data?.groups?.length > 1 && (
              <div className="flex overflow-x-scroll text-[14px] justify-around p-4">
                {data?.groups.map((group, index) => (
                  <button
                    key={index}
                    className={`m-1 flex h-[37px] w-[104px] items-center justify-center rounded-3xl ${
                      type === group
                        ? "bg-[#8e4d0e] text-white"
                        : "border-solid border border-[#c66a10] text-[#c66a10] bg-white"
                    }`}
                    onClick={() => setType(group)}
                  >
                    {group}
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className="w-[90%] flex flex-row justify-around items-center bg-white ml-5 p-2 rounded-md relative mt-2">
            <div className="flex flex-col text-[#c66a10] font-semibold">
              <button onClick={() => setStart((prev) => !prev)}>From</button>
              {start ? (
                <div className="absolute top-14 md:top-12 left-0  z-10 bg-white shadow-lg rounded-md overflow-hidden">
                  <Calendar
                    onChange={(date) => {
                      handleInitialChange(date);
                    }}
                    value={initial}
                    minDate={new Date()}
                    className="w-full"
                  />
                </div>
              ) : (
                <div
                  className="text-sm text-[#8e4d0e] w-full cursor-pointer"
                  onClick={() => setStart((prev) => !prev)}
                >
                  {moment(initial).format("DD/MM/YY, ddd")}
                </div>
              )}
            </div>
            <img src={arr} alt="to" height={24} width={24} />
            <div className="flex flex-col text-[#c66a10] font-semibold">
              <button onClick={() => setEnd((prev) => !prev)}>To</button>
              {end ? (
                <div className="absolute  top-14 md:top-12  right-0 z-10 bg-white shadow-lg rounded-md overflow-hidden">
                  <Calendar
                    onChange={(date) => {
                      handleFinalChange(date);
                    }}
                    minDate={initial ? initial : new Date()}
                    value={final}
                    className="w-full"
                  />
                </div>
              ) : (
                <div
                  className="text-sm text-[#8e4d0e] w-full cursor-pointer"
                  onClick={() => setEnd((prev) => !prev)}
                >
                  {moment(final).format("DD/MM/YY, ddd")}
                </div>
              )}
            </div>
          </div>
          <div
            className="flex items-center justify-start mt-5 overflow-x-scroll no-scrollbar px-5 gap-5"
            onClick={closeHandler}
          >
            {data && Object.keys(data).length && data?.passes?.length > 0 ? (
              data?.passes?.filter((item) => !type || item.group === type)
                .length > 0 ? (
                data.passes
                  ?.filter((item) => !type || item.group === type)
                  .map((item) => <QrImg data={item} key={item.id} />)
              ) : (
                <div className="flex items-center justify-center w-full text-[#c66a10] font-semibold">
                  No passes available for this selected type.
                </div>
              )
            ) : (
              <div className="flex items-center justify-center w-full text-[#c66a10] font-semibold">
                No passes available for today.
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Future;
